import { BuyToneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/buytone/buytonedto';
import { SubscriptionPlanDetailsDto } from 'src/com/sixdee/crbtportal/core/dto/subscriptionplandetails/subscriptionplandetailsdto';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { UpgradePackDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/upgradepack/upgradepackdto';
import { APIFeatures } from 'src/com/sixdee/crbtportal/core/util/apifeatures';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState } from '../../../toolkit/uicomponent';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UpgradePackAPIModelImpl } from './upgradeapimodel';
import { UpgradePackCSSStyleImpl } from './upgradepackcss';
import { UpgradePackViewImpl } from './upgradepackview';

export interface UpgradePackComponentProps extends UIComponentProps
{
    headerTitle:string;
    id:string;
    toneDto:ToneDto;
    channel?:string;
    closePopup(): void;
    showPopup(id:string,msg:string,type:AlertType):void;
}

export interface UpgradePackComponentState extends UIComponentState
{
    isHovered:boolean;
    onPackselected:string;
    isUpgradePackHovered:boolean;
   
}

export interface UpgradePackComponentHandler extends UIComponentHandler
{
    
    onUpgradePackHovered(isMonthlyHovered: boolean, isWeeklyHovered:boolean, isDailyHovered:boolean):void;
    onUpgradePackHoveredExit():void;
    onCancelClick():void;
    onConfirmClick():void;
    onClick(packName:string):void;


}

export class UpgradePackComponent extends UIComponentImpl<UpgradePackComponentProps, UpgradePackComponentState, SubscriptionPlanDetailsDto> 
implements UpgradePackComponentHandler
{
    constructor(props: UpgradePackComponentProps)
    {
        super(props);

        this.state = {isHovered:true, isUpgradePackHovered:true,onPackselected:this.getContext().getConfigurationSettings().getProperty("CRBT_VIP_OFFER_CODE")};
    }
  
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<SubscriptionPlanDetailsDto>
    {
        return new UpgradePackViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new UpgradePackCSSStyleImpl(applicationContext);
    }

   
    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new UpgradePackAPIModelImpl(applicationContext, apiModelHandler);
    }
   
    onUpgradePackHovered(isDailyHovered: boolean): void {
        this.setState({isUpgradePackHovered:isDailyHovered });
    }
    onUpgradePackHoveredExit(): void {
        this.setState({isUpgradePackHovered:true });
    }
   
    onCancelClick():void
    {
        this.props.context.getUserContext().setMsisdnB("");
        this.props.context.getUserContext().setSecToken("");
        this.props.context.getUserContext().setUserName("");
        this.props.context.getUserContext().setPackName("");
        this.props.context.getUserContext().setIsnewUser(false);
        this.props.context.setUserContext(this.props.context.getUserContext());
        this.props.closePopup();
    }

    onConfirmClick():void
    {
        if(this.getContext().getUserContext().getIsLoggedIn())
        {
            (this.getView() as UpgradePackViewImpl).showLoader();
             
            if(this.getContext().getUserContext().getIsNewUser())
            {
                let buyTone = new BuyToneDtoImpl();
                buyTone.setToneId(this.props.toneDto.getId());
                buyTone.setToneName(this.props.toneDto.getToneName());
                buyTone.setMsisdn(this.props.context.getUserContext().getMsisdnB());
                buyTone.setLanguage(this.props.context.getUserContext().getLanguage());
                console.log("Upgrade pack ========",this.state.onPackselected);
                buyTone.setPackName(this.state.onPackselected);
                buyTone.setUserName(this.props.context.getUserContext().getUsername());
                buyTone.setChannel(this.props.context.getUserContext().getChannelId());

                (this.getAPIModel() as UpgradePackAPIModelImpl).loggedInBuyTone(buyTone);
            }
            else
            {
                let upgradePack = new UpgradePackDtoImpl();
                upgradePack.setToneId(this.props.toneDto.getId());
                upgradePack.setToneName(this.props.toneDto.getToneName());
                upgradePack.setMsisdn(this.props.context.getUserContext().getMsisdnB());
                upgradePack.setLanguage(this.props.context.getUserContext().getLanguage());
                upgradePack.setPackName(this.state.onPackselected);
                upgradePack.setUserName(this.props.context.getUserContext().getUsername());
                upgradePack.setChannel(this.props.context.getUserContext().getChannelId());

                (this.getAPIModel() as UpgradePackAPIModelImpl).upgradePack(upgradePack);
            }
                
            
            // else
            // {
            //     (this.getView() as UpgradePackViewImpl).showLoader();
            //     let buyTone = new BuyToneDtoImpl();
            //     buyTone.setToneId(this.props.toneDto.getId());
            //     buyTone.setToneName(this.props.toneDto.getToneName());
            //     buyTone.setMsisdn(this.props.context.getUserContext().getMsisdnB());
            //     buyTone.setLanguage(this.props.context.getUserContext().getLanguage());
            //     buyTone.setPackName(this.state.onPackselected);
            //     buyTone.setUserName(this.props.context.getUserContext().getUsername());
            //     buyTone.setChannel(this.props.context.getUserContext().getChannelId());

            //     (this.getAPIModel() as UpgradePackAPIModelImpl).loggedInBuyTone(buyTone);
            // }
            
        }
        else
        {
            (this.getView() as UpgradePackViewImpl).showLoader();

            if(this.getContext().getUserContext().getIsNewUser())
            {
                let buyTone = new BuyToneDtoImpl();
                buyTone.setToneId(this.props.toneDto.getId());
                buyTone.setToneName(this.props.toneDto.getToneName());
                buyTone.setMsisdn(this.props.context.getUserContext().getMsisdnB());
                buyTone.setLanguage(this.props.context.getUserContext().getLanguage());
                buyTone.setPackName(this.state.onPackselected);
                buyTone.setUserName(this.props.context.getUserContext().getUsername());
                buyTone.setChannel(this.props.context.getUserContext().getChannelId());

                (this.getAPIModel() as UpgradePackAPIModelImpl).buyTone(buyTone);
            }
            
            else{
                let upgradePack = new UpgradePackDtoImpl();
                upgradePack.setToneId(this.props.toneDto.getId());
                upgradePack.setToneName(this.props.toneDto.getToneName());
                upgradePack.setMsisdn(this.props.context.getUserContext().getMsisdnB());
                upgradePack.setLanguage(this.props.context.getUserContext().getLanguage());
                upgradePack.setPackName(this.state.onPackselected);
                upgradePack.setUserName(this.props.context.getUserContext().getUsername());
                upgradePack.setChannel(this.props.context.getUserContext().getChannelId());

                (this.getAPIModel() as UpgradePackAPIModelImpl).upgradePackNonLoggedIn(upgradePack);
            
            }
               

            // else  
            // {
            //     (this.getView() as UpgradePackViewImpl).showLoader();
            //     let buyTone = new BuyToneDtoImpl();
            //     buyTone.setToneId(this.props.toneDto.getId());
            //     buyTone.setToneName(this.props.toneDto.getToneName());
            //     buyTone.setMsisdn(this.props.context.getUserContext().getMsisdnB());
            //     buyTone.setLanguage(this.props.context.getUserContext().getLanguage());
            //     buyTone.setPackName(this.state.onPackselected);
            //     buyTone.setUserName(this.props.context.getUserContext().getMsisdnB());
            //     buyTone.setChannel(this.props.context.getUserContext().getChannelId());

            //     (this.getAPIModel() as UpgradePackAPIModelImpl).buyTone(buyTone);
            // }
       
        }
    }


    onClick(packName:string):void{
        this.setState({onPackselected:packName});
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        // if(feature === APIFeatures.UPGRADE_PACK)
        // {
        //     let buyTone = new BuyToneDtoImpl();
        //     buyTone.setToneId(this.props.toneDto.getId());
        //     buyTone.setToneName(this.props.toneDto.getToneName());
        //     buyTone.setMsisdn(this.props.context.getUserContext().getMsisdnB());
        //     buyTone.setLanguage(this.props.context.getUserContext().getLanguage());
        //     buyTone.setPackName(this.state.onPackselected);
        //     buyTone.setUserName(this.props.context.getUserContext().getUsername());
        //     buyTone.setChannel(this.props.context.getUserContext().getChannelId());

        //     if(this.getContext().getUserContext().getIsLoggedIn())
        //     {
        //         (this.getAPIModel() as UpgradePackAPIModelImpl).loggedInBuyTone(buyTone);

        //     }
        //     else{
        //         (this.getAPIModel() as UpgradePackAPIModelImpl).buyTone(buyTone);

        //     }
        // }
        // else
        
            (this.getView() as UpgradePackViewImpl).dismissLoader();

            this.props.context.getUserContext().setMsisdnB("");
            this.props.context.getUserContext().setSecToken("");
            this.props.context.getUserContext().setUserName("");
            this.props.context.getUserContext().setPackName("");
            this.props.context.getUserContext().setIsnewUser(false);
            this.props.context.getUserContext().setPackName("");
            this.props.context.setUserContext(this.props.context.getUserContext());
            this.props.showPopup(this.getContext().getResources().getString(Strings.upgradePack),this.getContext().getResources().getString(Strings.your_order_is_successfully_completed),AlertType.SUCCESS);   
        
    }

    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        this.props.context.getUserContext().setMsisdnB("");
        this.props.context.getUserContext().setSecToken("");
        this.props.context.getUserContext().setUserName("");
        this.props.context.getUserContext().setPackName("");
        this.props.context.getUserContext().setIsnewUser(false);
        this.props.context.setUserContext(this.props.context.getUserContext());
        (this.getView() as UpgradePackViewImpl).dismissLoader();
        this.props.showPopup(this.props.context.getResources().getString(Strings.upgradePack),description,AlertType.ERROR);     

    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/upgrade_pack/upgradepackcomponent.tsx